import { TCampaigns } from "./types"
import "./styles.scss"
import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { CampaignsContext } from "./context"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import { CampaignsListing } from "./containers/listing"

export function Campaigns({ }: TCampaigns) {
    return <ContentSectionContainer className="campaignsContainer">
        <CampaignsContext.Provider value={{}}>
            <Routes>

                <Route index path={fetchRoute({ route: ERoutes.campaigns })} element={<CampaignsListing initTab="all" />} />
                <Route path={fetchRoute({ route: ERoutes.campaignDrafts })} element={<CampaignsListing initTab="incomplete" />} />
                <Route path={fetchRoute({ route: ERoutes.campaignOutbox })} element={<CampaignsListing initTab="delivering" />} />
                <Route path={fetchRoute({ route: ERoutes.campaignSent })} element={<CampaignsListing initTab="delivered" />} />

                <Route index path={"/"} element={<CampaignsListing initTab="all" />} />
                <Route index path={"/drafts"} element={<CampaignsListing initTab="incomplete" />} />
                <Route index path={"/outbox"} element={<CampaignsListing initTab="delivering" />} />
                <Route index path={"/sent"} element={<CampaignsListing initTab="delivered" />} />

            </Routes>
        </CampaignsContext.Provider>
    </ContentSectionContainer >
}